<template>
    <div class="simple-treatment-selector--container">
        <div class="simple-treatment-selector">
            <br>
            <div v-for="(item, i) in treatmentTemplates"
                 v-show="item.active"
                 :key="i"
                 class="simple-treatment-selector--item"
                 :class="item.template.full_jaw ? 'simple-treatment-selector--item--full-jaw' : 'simple-treatment-selector--item--normal'"
            >
                <v-btn :id="`pm-smart-treatment-item--button-${i}`" block :class="$theme.contentBg" class="elevation-0 simple-treatment-selector--button"
                       @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd(item)">
                    <div :class="$theme.defaultText" class="roboto f13 bold--text simple-treatment-selector--button-content">
                        <span ref="treatmentButton" v-html="item.title" />
                    </div>
                </v-btn>
            </div>
            <br>&nbsp;
        </div>
        <div id="simple-treatment-selector-mask" :class="$theme.dark ? 'dark' : 'light'" />
    </div>
</template>

<style>
    body {
        counter-reset: treatment_button_normal;
    }
    .simple-treatment-selector--container {
        counter-reset: treatment_button_full_jaw;
    }

    @media (min-width: 700px) {
        .simple-treatment-selector {
            padding-right: 20px !important;
        }

        .simple-treatment-selector--item::before {
            width: 22px !important;
            line-height: 20px !important;
            font-size: 12px !important;
        }
    }

    .simple-treatment-selector--item::before {
        position: absolute;
        left: 0px;
        top: 3px;
        background: #fff;
        width: 18px;
        line-height: 16px;
        display: block;
        border-radius: 50%;
        border-width: 1px;
        border-style: solid;
        z-index: 3;
        text-align: center;
        font-size: 10px;
        font-weight: 600;
    }
    .simple-treatment-selector--item--full-jaw:before {
      counter-increment: treatment_button_full_jaw;
      border-color: rgba(40, 98, 230, 1);
      color: rgba(40, 98, 230, 1);
      content: counter(treatment_button_full_jaw);
    }
    .simple-treatment-selector--item--normal:before {
      counter-increment: treatment_button_normal;
      border-color: #e91e63;
      color: #e91e63;
      content: counter(treatment_button_normal);
    }

    .simple-treatment-selector--container {
        padding: 0;
        height: 100%;
    }

    .simple-treatment-selector--container * {
        -webkit-transform: translate3d(0,0,0);
    }

     .simple-treatment-selector {
         overflow-y: auto;
         -webkit-overflow-scrolling: touch;
         scroll-behavior: smooth;
         padding: 0 8px 0 0;
         position: relative;
         height: 100%;
    }

    .simple-treatment-selector--item {
        position: relative;
        padding: 3px;
        float: left;
        height: 80px;
        width: 100%;
    }

    .simple-treatment-selector--button {
        margin: 1px 0!important;
        padding: 8px 9px 8px 9px!important;
        height: auto!important;
        border-radius: 20px;
        min-width: auto!important;
        border: 2px solid #FCE4EC!important;
    }

    .simple-treatment-selector--button-content {
        text-overflow: ellipsis;
        overflow: visible;
        white-space: nowrap;
        font-weight: 600!important;
    }
    .simple-treatment-selector--button-content span {
        font-weight: 600!important;
    }

    .simple-treatment-selector--item--full-jaw .simple-treatment-selector--button-content {
        /*color: #880E4F;*/
        color: rgba(0, 0, 0, 1);
    }

    .simple-treatment-selector--item--full-jaw .simple-treatment-selector--button {
        border: 1px solid #0D47A1 !important;
    }

    .simple-treatment-selector--item--normal .simple-treatment-selector--button-content {
        /*color: #0D47A1;*/
        color: rgba(0, 0, 0, 1);
    }

    .simple-treatment-selector--button-content {
        display: flex;
        justify-content: center;
        white-space: initial;
        line-height: 14px;
        font-size: 11px;
        height: 44px;
        align-items: center;

        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: visible;
    }


    @media (min-width: 700px) {
        .simple-treatment-selector--item {
            height: 96px;
        }

        .simple-treatment-selector--button-content {
            font-size: 15px;
            height: 55px;
            line-height: 20px;
        }

        .simple-treatment-selector--button {
            border-radius: 24px;
        }

        .pm-plan-selector-container--default {
            margin-bottom: 30px;
        }
    }

    @media (orientation: portrait) and (max-width: 414px) {
        /*.simple-treatment-selector--button-content {
            font-size: 12px;
            letter-spacing: -0.5px;
        }*/
    }

    @media (orientation: portrait) and (max-width: 375px) {
            /*.simple-treatment-selector--button-content {
                font-size: 12px;
                letter-spacing: -0.5px;
            }*/
    }

    @media (orientation: portrait) and (max-width: 320px) {
        /*.simple-treatment-selector--button-content {
            font-size: 11px;
            letter-spacing: -1px;
        }*/
    }

    .simple-treatment-selector--item--normal .simple-treatment-selector--button {
        border: 1px solid #e91e63 !important;
    }

    .simple-treatment-selector::-webkit-scrollbar {
        width: 0px;
    }

    #simple-treatment-selector-mask {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        overflow: hidden;
        pointer-events: none;
    }

    #simple-treatment-selector-mask:before,
    #simple-treatment-selector-mask:after {
         pointer-events: none;
         content: "";
         display: block;
         left: 0;
         right: 0;
         width: 100%;
         height: 30px;
         position: absolute;
    }
    @media (min-width: 700px) and (orientation: portrait) {
        #simple-treatment-selector-mask:after {
            height: 90px;
            border-bottom: 30px solid #fff;
        }
    }

    #simple-treatment-selector-mask.light:before {
         background: linear-gradient(180deg, rgba(255,255,255,1) 10%, rgba(255,255,255,0) 100%);
         top: -2px;
    }

    #simple-treatment-selector-mask.light:after {
         background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 90%);
         bottom: -1px;
    }
    #simple-treatment-selector-mask.dark:before {
         background: linear-gradient(180deg, rgba(33,33,33,1) 10%, rgba(33,33,33,0) 100%);
         top: -2px;
    }

    #simple-treatment-selector-mask.dark:after {
         background: linear-gradient(0deg, rgba(33,33,33,1) 0%, rgba(33,33,33,0) 90%);
         bottom: -1px;
    }
    .simple-treatment-selector--button-active {
        background: rgba(40, 98, 230,.05)!important;
    }
</style>

<script>
// eslint-disable-next-line no-unused-vars no-console
const log = console.log.bind(console);

export default {
    data() {
        return ({});
    },
    created() {
        this.treatmentTemplates = this.getTemplates();
        this.isMoving = false;
    },
    activated() {
        this.treatmentTemplates = this.getTemplates();
        this.$forceUpdate(); // required to re-render if buttons were activated/deactivated in the pricelist
        window.setTimeout(() => {
            this.resizeButtons();
        }, 100);
    },
    mounted() {
        window.addEventListener("resize", this.resizeButtons);
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeButtons);
    },
    methods: {
        onTouchStart() {
            this.isMoving = false;
        },

        onTouchMove() {
            this.isMoving = true;
        },

        onTouchEnd(item) {
            if (this.isMoving) {
                this.isMoving = false;
                return;
            }
            event.stopPropagation();
            event.preventDefault();
            this.selectItem(item);
        },


        selectItem(item) {
            window.latestSmartTreatment = item.template.title;
            this.$emit('select', item);
            try {
                let el = event.target;
                let prev = document.querySelector('.simple-treatment-selector--button-active');
                if (prev) prev.classList.remove('simple-treatment-selector--button-active');
                el.closest(".simple-treatment-selector--button").classList.add('simple-treatment-selector--button-active');
            } catch(error) {
                captureException(error);
            }
        },
        resizeButtons() {
            const lineHeightDense = 14;
            const lineHeightNormal = 16;

            this.$refs.treatmentButton && this.$refs.treatmentButton.forEach((button) => {
                const $parent = button.closest("div");
                $parent.style.lineHeight = lineHeightDense + "px";
                const rows = button.offsetHeight / lineHeightDense; // offset height is the default line height * row count
                if (rows > 0 && rows <= 2) {
                    $parent.style.lineHeight = lineHeightNormal + "px";
                } else {
                    $parent.style.lineHeight = lineHeightDense + "px";
                }
            });
        },
        // called by parent
        scrollTop() {
            this.$nextTick(()=>{
                const el = document.querySelector(".simple-treatment-selector");
                if (!el) return;
                el.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "auto",
                });
            });
        },
        getTemplates() {
            const items = [];
            const templates = this.$store.state.localSettings.protocols;
            for (const i of Object.keys(templates)) {
                if (templates[i].title === "fast_and_fixed_4" && localStorage.getItem("dc_free_treatment_fast_and_fixed") !== "true") continue;
                if (templates[i].title === "fast_and_fixed_6" && localStorage.getItem("dc_free_treatment_fast_and_fixed") !== "true") continue;


                let title = this.$t("plan_simple.template_"+templates[i].title);
                title = title.replace("+", "+<br>");
                items.push({
                    active: parseInt(templates[i].active) !== 0,
                    template: templates[i],
                    title: title,
                });
            }
            const sortedItems = [];
            items.forEach((item) => {
                if (typeof item.template === "undefined") return;
                if (!item.template.full_jaw) sortedItems.push(item);
            });
            items.forEach((item) => {
                if (typeof item.template === "undefined") return;
                if (item.template.full_jaw) sortedItems.push(item);
            });

            return sortedItems;
        },

        modifyOrdering(items) {
            try {
                const sortedItems = [];
                items.forEach((item) => {
                    if (typeof item.template === "undefined") return;
                    if (!item.template.full_jaw) sortedItems.push(item);
                });
                items.forEach((item) => {
                    if (typeof item.template === "undefined") return;
                    if (item.template.full_jaw) sortedItems.push(item);
                });

                return sortedItems;
            } catch(error) {
                captureException(error);
            }
        },
    },
};
</script>
